<template>
  <div class="blessing-bag">
    <div class="wrapper">
      <div class="head">抖币福袋</div>
      <van-cell
        title="人均可得抖币"
        :value="form.doubi"
        :border="false"
        is-link
        @click="
          activeStr = 'doubi';
          show = true;
        "
      />
      <van-cell
        title="参与对象"
        :value="form.participants"
        :border="false"
        is-link
        @click="showParticipants = true"
      />
      <van-cell
        title="可中奖人数"
        :value="form.maxNum"
        :border="false"
        is-link
        @click="
          activeStr = 'maxNum';
          show = true;
        "
      />
      <van-cell
        title="参与方式"
        :value="form.mode"
        :border="false"
        is-link
        @click="
          activeStr = 'mode';
          show = true;
        "
      />
      <div class="p-input" v-show="form.mode == '口令参与'">
        <el-input
          type="text"
          placeholder="请输入口令"
          v-model="form.password"
          size="small"
          maxlength="15"
          show-word-limit
        ></el-input>
      </div>
      <van-cell
        title="倒计时"
        :value="form.countDown"
        :border="false"
        is-link
        @click="
          activeStr = 'countDown';
          show = true;
        "
      />

      <div class="s-btn" @click="handleSubmit">
        发起福袋（{{ totalCount }}抖币）
      </div>
    </div>

    <van-popup v-model="show" position="bottom">
      <van-picker
        title="标题"
        show-toolbar
        :visible-item-count="5"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      >
        <span slot="title"></span>
        <span slot="confirm" style="color: #f72e59">确定</span>
      </van-picker>
    </van-popup>

    <van-action-sheet
      v-model="showParticipants"
      :actions="[{ name: '仅粉丝团可参与' }, { name: '所有观众可参与' }]"
      @select="onSelect"
    />
  </div>
</template>

<script>
import "vant/lib/index.css";
import { Cell, Field, Picker, Popup, ActionSheet, Dialog } from "vant";
import { submit } from "@/api/chapterMock";

export default {
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      form: {
        doubi: "10抖币",
        participants: "所有观众可参与",
        maxNum: "10人",
        mode: "口令参与",
        password: "",
        countDown: "3分钟",
      },
      activeStr: "",
      show: false,
      showParticipants: false,
    };
  },
  computed: {
    columns() {
      if (this.activeStr == "doubi")
        return ["10抖币", "30抖币", "50抖币", "100抖币", "1000抖币"];
      else if (this.activeStr == "maxNum")
        return [
          "1人",
          "3人",
          "5人",
          "10人",
          "15人",
          "20人",
          "50人",
          "100人",
          "200人",
        ];
      else if (this.activeStr == "mode") return ["口令参与", "分享直播间"];
      else if (this.activeStr == "countDown")
        return ["1分钟", "3分钟", "5分钟", "10分钟"];
    },
    totalCount() {
      return parseInt(this.form.doubi) * parseInt(this.form.maxNum);
    },
  },
  methods: {
    onConfirm(val) {
      this.form[this.activeStr] = val;
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onSelect(item) {
      this.showParticipants = false;
      this.form.participants = item.name;
    },
    handleSubmit() {
      // console.log(this.form);
      Dialog.confirm({
        title: "提示",
        message: "确认提交内容？",
      }).then(() => {
        const classChapterId = localStorage.getItem("mockChapterId");
        submit({
          classChapterId,
          content: JSON.stringify(this.form),
        }).then((res) => {
          Dialog.alert({
            title: "提示",
            message: "提交完成",
          }).then(() => {
            window.close();
            window.parent.close();
          });
        });
        // console.log(JSON.stringify(this.info));
      });
    },
  },
};
</script>

<style lang="less" scoped>
.blessing-bag {
  position: relative;
  height: 100vh;
  .wrapper {
    position: absolute;
    bottom: 0;
    width: 100%;
    // height: 100vw;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: #181218;
    overflow: hidden;
    .head {
      padding: 15px 0;
      text-align: center;
      color: #fff;
      font-weight: bold;
      border-bottom: solid 1px #606266;
      background-image: linear-gradient(#570b3e, #161216);
    }
    ::v-deep .van-cell {
      color: #fff;
      background-color: transparent;
    }
    ::v-deep .p-input {
      padding: 0 15px;
      .el-input__inner {
        color: #fff;
        background-color: #606266;
        border-color: #606266;
      }
      .el-input__count-inner {
        color: #c0c4cc;
        background-color: #606266;
      }
    }
    .s-btn {
      margin: 100px 15px 15px;
      padding: 10px 0;
      text-align: center;
      color: #fff;
      background-color: #f72e59;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
</style>